<div class="time-line">
  <nz-timeline>
    <nz-timeline-item *ngFor="let node of this.timeLineNodes" [nzDot]="iconTemplate" [nzColor]="node.Color">
      <p class="node-text">{{node.Text}}</p>
      <p class="node-details">
        <nz-space>
          <nz-space-item>
            <i nz-icon nzType="calendar" nzTheme="outline" nz-tooltip [nzTooltipTitle]="'Creation date' | locale"></i> {{node.Date}}
          </nz-space-item>
          <nz-space-item>
            <nz-divider nzType="vertical"></nz-divider>
          </nz-space-item>
          <nz-space-item>
            <i nz-icon nzType="user" nzTheme="outline" nz-tooltip [nzTooltipTitle]="'Created by' | locale"></i> {{node.UserName}}
          </nz-space-item>
          <nz-space-item>
            <nz-divider nzType="vertical"></nz-divider>
          </nz-space-item>
          <nz-space-item>
            {{node.Currency}} {{node.Total}}
          </nz-space-item>
        </nz-space>
      </p>
      <ng-template #iconTemplate>
        <i nz-icon [nzType]="node.Icon" style="font-size: 16px;"></i>
      </ng-template>
    </nz-timeline-item>
  </nz-timeline>
</div>
